import { twMerge } from 'tailwind-merge';

type DividerProps = {
  className?: string;
};

export function Divider(props: DividerProps) {
  const { className } = props;
  return (
    <span className={twMerge(['inline-block h-px w-full bg-branding-gray px-2', className])}></span>
  );
}
